import { useQuery } from '@tanstack/react-query';
import { sharingApi } from '../../lib/api/sharingApi';
const SHARED_LIMIT = 50;
/** Chats shared with the current user (CollabService.ListSharedWithMe). */ export function useSharedWithMe() {
    const query = useQuery({
        queryKey: [
            'shared-with-me',
            'rail'
        ],
        queryFn: ()=>sharingApi.getSharedWithMe(1, SHARED_LIMIT),
        staleTime: 30000
    });
    return {
        chats: query.data?.chats ?? [],
        total: query.data?.pagination.total ?? query.data?.chats.length ?? 0,
        isLoading: query.isLoading,
        isError: query.isError,
        isLoaded: query.isSuccess,
        refetch: query.refetch
    };
}
